<template>
    <v-list
        dense
        nav
        class="py-0"
    >
        <v-list-item two-line>
            <v-list-item-avatar>
                <v-icon large class="secondary--text">mdi-account-circle</v-icon>
            </v-list-item-avatar>
            
            <v-list-item-content>
                <v-list-item-title class="secondary--text">
                    {{ companyName }}
                </v-list-item-title>
                <v-list-item-subtitle class="secondary--text">
                    {{ userName }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        
        <v-divider></v-divider>
        
        <v-list-item
            v-for="item in items"
            :key="item.title"
            @click=routeHandler(item.route);
            color="secondary"
        >
            <v-list-item-icon>
                <v-icon large class="secondary--text"> {{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="secondary--text">{{ item.title }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-group
            value="true"
            active-class="secondary--text"
        >   
            <v-icon slot="prependIcon" large color="secondary">mdi-account-cog-outline</v-icon>
            <template v-slot:activator>
                <v-list-item-title class="secondary--text">Management</v-list-item-title>
            </template>
            <v-list-item
                v-for="manage in management"
                :key="manage.title"
                @click="routeHandler(manage.route)"
                class="secondary--text"
            >
                <v-list-item-icon>
                    <v-icon large class="secondary--text"> {{ manage.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="secondary--text">{{ manage.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list-group>        
        <v-list-group
            v-if="authContext.isSiteAdmin"
            value="true"
            active-class="secondary--text"
        >   
            <v-icon slot="prependIcon" large color="secondary">mdi-web</v-icon>
            <template v-slot:activator>
                <v-list-item-title class="secondary--text">Site Admin</v-list-item-title>
            </template>
            <v-list-item
                v-for="admin in siteAdmin"
                :key="admin.title"
                @click="routeHandler(admin.route)"
                class="secondary--text"
            >
                <v-list-item-icon>
                    <v-icon large class="secondary--text"> {{ admin.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="secondary--text">{{ admin.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list-group>
    </v-list>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    data: () => ({
        items: [
            { title: 'Dashboard', icon: 'mdi-speedometer', route: 'dashboard' },
            { title: 'Client / Opps', icon: 'mdi-account-multiple-plus-outline', route: 'clientmanagement' },
            { title: 'Proposal', icon: 'mdi-sticker-plus-outline', route: 'proposal' },
        ],
        management: [
            { title: 'Company', icon: '', route: 'mgmtCompany' },
            { title: 'Templates', icon: '', route: 'mgmtTemplates' },
            { title: 'Pricing', icon: '', route: 'mgmtPricing' },
        ],
        siteAdmin: [
            { title: 'TPA Accounts', icon: '', route: 'adminTPA'},
            { title: 'Broker Dealers', icon: '', route: 'adminBroker'},
            { title: 'Wholesalers', icon: '', route: 'adminWholesaler'},
        ],
        companyName: null,
        userName: null
    }),    
    mounted() {
         setTimeout(() => {
            this.companyName = sessionStorage.getItem('tpaName');
            this.userName = sessionStorage.getItem('userName');
        }, 500);

    },
    computed: {
        ...mapGetters({
            authContext: 'authContext',
        }),
        mobile () {
            switch (this.$vuetify.breakpoint.name) {
              case 'xs': return true;
              case 'sm': return true;
              case 'md': return false;
              case 'lg': return false;
              case 'xl': return false;
            }
            return null;
        },
    },
    methods: {
        routeHandler(route) {
            switch(route){
                case 'dashboard':
                    this.$router.push({
                        name: 'dashboard',
                    })
                    break;
                case 'clientmanagement':
                    this.$router.push({
                        name: 'clientmanagement'
                    })
                    break;
                case 'proposal':
                    if (this.mobile === false){
                        this.$router.push({
                            name: 'proposal',
                            params: {
                                showComp: 'List',
                                }
                            })
                    } else {
                        this.$router.push({
                            name: 'proposal',
                            params: {
                                showComp: 'Builder',
                                }
                            })
                    }                    
                    break;
                // case 'tpamanagement':
                //     this.$router.push({
                //         name: 'tpamanagement'
                //         })
                //     break;
                case 'mgmtCompany':
                    this.$router.push({
                        name: 'mgmtcompany'
                    })
                    break;
                case 'mgmtTemplates':
                    this.$router.push({
                        name: 'mgmttemplates'
                    })
                    break;
                case 'mgmtPricing':
                    this.$router.push({
                        name: 'mgmtpricing'
                    })
                    break;
                case 'adminTPA':
                    this.$router.push({
                        name: 'adminTpa',
                    })
                    break;
                case 'adminBroker':
                    this.$router.push({
                        name: 'adminBroker',
                    })
                    break;
                case 'adminWholesaler':
                    this.$router.push({
                        name: 'adminWholesaler',
                    })
                    break;
            }
        }
    }
};
</script>